<template>
  <div class="utility-cell">
    <div
      v-if="isEditingUtility"
      style="margin:auto;text-align:center;"
    >
      <v-text-field
        :value="profitMarginNumber"
        suffix="%"
        outlined
        dense
        hide-details
        rounded
        @input="$emit('update:profit-margin', $event)"
      />
    </div>

    <div
      v-else
      style="margin:auto;text-align:center;"
    >
      <div>{{ currency(utilidadAmountNumber) }}</div>
      <div>{{ utilidadPct }}%</div>
    </div>
  </div>
</template>

<script>
import { IVA_RATE } from './pricing'

export default {
  name: 'UtilityCell',
  props: {
    editMode: {
      type: String,
      required: true
    },
    price: {
      type: [String, Number],
      required: true
    },
    priceIva: {
      type: [String, Number],
      required: true
    },
    currentCost: {
      type: [String, Number],
      required: true
    },
    profitMargin: {
      type: [String, Number],
      required: true
    },
    tier: {
      type: String,
      required: true
    }
  },
  computed: {
    isEditingUtility() {
      return this.editMode === 'utilidad'
    },
    costNumber() {
      const n = parseFloat(this.currentCost || 0)
      return isNaN(n) ? 0 : n
    },
    priceNoIvaNumber() {
      const raw = parseFloat(this.price || 0)
      if (!isNaN(raw) && raw > 0) return raw
      const ivaRaw = parseFloat(this.priceIva || 0)
      if (!isNaN(ivaRaw) && ivaRaw > 0) return ivaRaw / IVA_RATE
      return 0
    },
    utilidadAmountNumber() {
      const diff = this.priceNoIvaNumber - this.costNumber
      return isNaN(diff) ? 0 : diff
    },
    utilidadPct() {
      if (!this.costNumber || this.costNumber <= 0) return '0.00'
      const pct = (this.utilidadAmountNumber / this.costNumber) * 100
      return pct.toFixed(2)
    },
    profitMarginNumber() {
      const n = parseFloat(this.profitMargin || 0)
      return isNaN(n) ? 0 : n
    }
  },
  methods: {
    currency(v) {
      const n = parseFloat(v || 0)
      return n.toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN'
      })
    }
  }
}
</script>

<style scoped>
.utility-cell {
  width:100%;
  height:100%;
  display:flex;
  align-items:center;
  justify-content:center;
  text-align:center;
}
</style>
